module.exports = __webpack_public_path__ + "img/oufu_58x80x10b.prt.81d7f20d.jpg";